 <template>
    <div class="doubleBars"></div>
</template>

<script>
export default {
    name: '',
    props:{
        pondsid:Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            yData:[]
        }
    },
    methods: {
        setData(){
            this.request.get("/api/Echart/getpage2",{
                params: {
                    pondsid:this.pondsid,
                    param: "sal",
                    number:10
                }
            }).then(res => {
                if(res.code == 200){
                    let data = res.data;
                    this.xData = data.map(item =>{ // 假设 item.time 是 "2024-03-30T10:03:47"  
                        const timeParts = item.time.split(' '); // 将字符串分割为日期和时间两部分  
                        const datePart = timeParts[0]; // 获取日期部分，即 "2024-03-30"  
                        const timePart = timeParts[1]; // 获取时间部分，即 "10:03:47"  
                    
                        // 从日期部分提取月和日  
                        const month = datePart.substring(5, 7); // "03"  
                        const day = datePart.substring(8, 10); // "30"  
                    
                        // 从时间部分提取时和分  
                        const hour = timePart.substring(0, 2); // "10"  
                        const minute = timePart.substring(3, 5); // "03"  
                    
                        // 拼接成 "月 日 时 分" 的格式  
                        return `${month}-${day} ${hour}:${minute}`; });
                    this.yData = data.map(item => item.sal)    
                }
                this.setChart()
            })
        },
        setChart() {
            const allNull = this.yData.every(item => item === null);
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'line'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#6dd0e3',
                        fontSize: 10,
                    },
                },
                graphic: allNull ? [{
            type: 'text',
            left: 'center', // 根据需要调整位置
            top: 'center',
            style: {
                text: '暂无此参数数据',
                textAlign: 'center',
                fill: '#ccc', // 文本颜色
                fontSize: 25
            }
        }] : [],
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: true
                    },
                    z: 2,
                    data: this.xData
                },
                yAxis:
                    {
                        type: 'value',
                        // interval: 5000,
                        min: 22,
                        max: 28,
                        // splitNumber: 5,
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10
                        },
                        splitLine: {
                            show: false,
                        },
                        name: '(ppt)',
                        nameGap: -10,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                    },

                series: [{
                    name: '盐度',
                    type: 'line',
                    symbol: 'none',
                    smooth: true,
                    data: this.yData,
                    lineStyle: {
                        width: 1,
                        color:{
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#FF3E96' // 0% 处的颜色
                            },
                                {
                                    offset: 0.5, color: '#FF3E96' // 40% 处的颜色
                                }, {
                                    offset: 1, color: '#694d9f' // 100% 处的颜色
                                }],
                            global: false // 缺省为 false
                        } //背景渐变色
                    },
                    itemStyle: {
                        color: '#8552a1'
                    },
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#F6416C' // 0% 处的颜色
                            },
                            {
                                offset: 0.8, color: 'rgba(255, 246, 183, 0.8)' // 0% 处的颜色
                            },
                            {
                                offset: 1, color: 'rgba(255, 246, 183, 0)' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }, //背景渐变色
                        origin: 'start'
                    }
                },
                ]
            };

            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
        }
    },
    mounted() {
        this.setData()
    },
    watch: {
        pondsid() {
            this.setData()
        }
    }
}
</script>

<style lang="less" scoped>
.doubleBars {
    width: 100%;
    height: 100%;
}
</style>
